import PropTypes from 'prop-types';
import React from 'react';
import StyledStickyDrawer from './styled-sticky-drawer';

const { forwardRef } = React;

const propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	open: PropTypes.bool,
	transition: PropTypes.string,
	zIndex: PropTypes.string,
};

const defaultProps = {
	className: undefined,
	dataTestId: undefined,
	open: false,
	transition: '200ms',
	zIndex: '1',
};

const StickyDrawer = forwardRef(
	({ children, className, dataTestId, open, transition, zIndex, ...rest }, ref) => (
		<StyledStickyDrawer
			aria-hidden={open ? undefined : true}
			className={className}
			data-testid={dataTestId || 'fuse-sticky-drawer-test-id'}
			open={open}
			ref={ref}
			transition={transition}
			zIndex={zIndex}
			{...rest}
		>
			{children}
		</StyledStickyDrawer>
	),
);

StickyDrawer.propTypes = propTypes;
StickyDrawer.defaultProps = defaultProps;

export default StickyDrawer;
export { StickyDrawer };
